import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
  };
  children?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  children
}) => {
  return (
    <div className="text-center py-12">
      {Icon && (
        <div className="mx-auto w-24 h-24 text-gray-400 mb-4">
          <Icon className="w-full h-full" />
        </div>
      )}
      
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      
      {description && (
        <p className="text-gray-500 mb-6 max-w-md mx-auto">{description}</p>
      )}

      {action && (
        <button
          onClick={action.onClick}
          className={`inline-flex items-center px-4 py-2 border rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 ${
            action.variant === 'secondary'
              ? 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-gray-500'
              : 'border-transparent text-white bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
          }`}
        >
          {action.label}
        </button>
      )}

      {children}
    </div>
  );
};